// extracted by mini-css-extract-plugin
export default {"container":"skills_container__ZVx5G","skillsList":"skills_skillsList__9YKBE","skills":"skills_skills__ce8XL","skill":"skills_skill__d8J4F","name":"skills_name__rW5ST"};